import useSeo from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import { BookingWizard } from "@/components/BookingWizard";
import { HoursList } from "@/components/Footer";
import { IMG } from "@/lib/catalog";

export default function Appointments() {
  useSeo("Agendar cita", "Agenda tu cita en línea en el Taller de Suspensiones La Gringa, Mérida. Elige servicio, día y hora disponibles.");
  return (
    <>
      <PageHero eyebrow="Citas en línea" title="Agenda tu cita" image={IMG.brake}
        subtitle="Elige el servicio, el día y la hora que te acomoden. También puedes pedirle al asistente virtual que te ayude a reservar." />
      <section className="container-x grid gap-10 py-16 lg:grid-cols-[1fr,320px]">
        <div className="card-dark p-6 sm:p-10"><BookingWizard /></div>
        <aside className="space-y-6">
          <div className="card-dark p-6">
            <h2 className="eyebrow mb-4">Horario de atención</h2>
            <HoursList />
          </div>
          <div className="card-dark p-6 text-sm text-mute">
            <h2 className="eyebrow mb-3">¿Prefieres llamar?</h2>
            <a href="tel:+529991919300" className="font-display text-2xl font-bold text-ink">999-191-9300</a>
            <p className="mt-2">Llámanos o escríbenos por WhatsApp para dudas o cambios de cita.</p>
          </div>
        </aside>
      </section>
    </>
  );
}
